/**
 * Access-token store for the IAM handoff flow. The token lives IN MEMORY ONLY (XSS-safe):
 * it is obtained from the handoff exchange and lost on reload, which simply re-triggers the
 * handoff. There is no refresh token — the IAM owns session lifetime.
 */
let accessToken: string | null = null;

export const tokenStorage = {
  getAccess(): string | null {
    return accessToken;
  },
  setAccess(token: string): void {
    accessToken = token;
  },
  clearAccess(): void {
    accessToken = null;
  },
  clear(): void {
    accessToken = null;
  },
};
